module.exports = __webpack_public_path__ + "img/success.0278160e.png";